<template>
  <div class="container mt-6 px-4 lg:mt-15 lg:px-0 bg-white">
    <div class="flex flex-col justify-center items-center">
      <img width="44" :src="require('@/assets/images/line-icon-complete.svg')" alt="" />
      <div class="big-title text-green-150 mt-3">{{ $t('ec-line005.lineGuide.title') }}</div>
    </div>
    <div class="w-full text-left mt-4">
      <p class="leading-6 text-lg">{{ $t('ec-line005.lineGuide.hint1') }}</p>
    </div>
    <div class="flex flex-col lg:flex-row justify-center gap-5 items-center flex-1">
      <div class="hidden lg:flex flex-col items-center mt-5">
        <h2 class="text-lg">{{ $t('ec-line005.lineGuide.hint3') }}</h2>
        <img width="250" height="250" class="mt-2" :src="qrCodeCanvas" />
      </div>
      <div class="flex flex-col items-center mt-10 w-full lg:w-auto">
        <div class="line-steps">
          <span class="line-steps__title">{{ $t('ec-line005.lineGuide.step', { val: 1 }) }}</span>
          <div class="flex flex-col lg:hidden">
            <p class="font-black text-base text-white mb-2">
              {{ $t('ec-line005.lineGuide.clickLineButton') }}
            </p>
            <el-button class="line-steps__button w-40 self-center" @click="openLine">{{
              $t('ec-line005.lineGuide.lineButton')
            }}</el-button>
          </div>
          <p class="font-black text-lg text-white text-center hidden lg:block">
            {{ $t('ec-line005.lineGuide.readQrCode') }}
          </p>
        </div>
        <img :src="require('@/assets/images/ec-line005-line-guild-arrow.svg')" width="40" />
        <div class="line-steps">
          <span class="line-steps__title">{{ $t('ec-line005.lineGuide.step', { val: 2 }) }}</span>
          <p class="font-black text-base lg:text-lg text-white text-center">
            {{ $t('ec-line005.lineGuide.addFriendOffical') }}
          </p>
        </div>
        <img :src="require('@/assets/images/ec-line005-line-guild-arrow.svg')" width="40" />
        <div class="line-steps">
          <span class="line-steps__title">{{ $t('ec-line005.lineGuide.step', { val: 3 }) }}</span>
          <p class="font-black text-base lg:text-lg text-white text-center">
            {{ $t('ec-line005.lineGuide.linkCompleted') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  props: { qrCode: { type: String, default: () => '' } },
  data() {
    return {
      qrCodeCanvas: null,
    }
  },
  watch: {
    qrCode: {
      handler(val) {
        val && this.createQrCode()
      },
      immediate: true,
    },
  },
  methods: {
    createQrCode() {
      this.qrCode ? QRCode.toDataURL(this.qrCode).then((url) => (this.qrCodeCanvas = url)) : ''
    },
    openLine() {
      this.$emit('click-line')
    },
  },
}
</script>

<style lang="scss" scope>
@import '@/assets/css/components/ec-line005/line-guide-step.scss';
</style>
